import { AxiosResponse } from 'axios';
import { CancellationDueDeath } from 'cancellations/view-models/cancellation-due-death';
import { ActCategory } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';
import { transformChangeControlDataForm } from './transform-change-control-data-form';
import { CodeStepButtonsCancellation } from 'cancellations/constants/code-step-buttons-cancellation';
import { transformDeathDataForm } from './transform-death-data-form';
import { checkError, formatErrorMunicipalityForeign } from '../transform-family-detail/check-error';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';

export const transformDeath = (
  response: AxiosResponse<HttpResponse<ActCategory>>
): { data: CancellationDueDeath; error?: string } => {
  const castedRes = response.data.payload.consultazioneANSCResponse?.modelEventoDTO || [];
  const modelEventoDTO = castedRes[0] || {};

  const castedDatiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};

  const intestatari = castedDatiAggiuntiviSide.intestatariTranscod || [];
  const intestatario = intestatari[0] || {};

  const datiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};

  const changeControlDataForm = transformChangeControlDataForm(modelEventoDTO);
  const deathDataForm = transformDeathDataForm(modelEventoDTO, datiAggiuntiviSide);

  const errorIntestatario: string = checkError(intestatario);

  let errorDeath;

  const isForeign = datiAggiuntiviSide?.datiDiMorteTranscod?.idStatoMorte !== CODE_STATE_ITALIAN;

  if (isForeign && !datiAggiuntiviSide.datiDiMorteTranscod?.idComuneMorte) {
    errorDeath = formatErrorMunicipalityForeign(
      datiAggiuntiviSide.datiDiMorteTranscod?.comuneEstero,
      datiAggiuntiviSide.datiDiMorteTranscod?.nomeStatoMorte
    );
  }

  return {
    data: {
      activeStep: CodeStepButtonsCancellation.datiCancellazione,
      changeControlDataForm,
      deathDataForm,
    },
    error: errorIntestatario || errorDeath,
  };
};
